import React, { useRef, useState } from 'react'
import { BannerContainer, AudioContainer, AudioHeader, AudioContent, AudioTitle, ProgressBarContainer, Progress, TimeDisplay, Controls, Footer, OptionsIcon, Container, Content, ControlsContainer, Title, TitleContent } from './styled'
import { Icon } from 'ui/styled'
import { parseStrapiImage } from 'utils'
import ExternalResourceLink from 'components/ExternalResourceLink'

export default function CourseAudio({ course }) {
  const audioRef = useRef(null)
  const [isPlaying, setIsPlaying] = useState(false)
  const [currentTime, setCurrentTime] = useState(0)
  const [totalDuration, setTotalDuration] = useState(0)
  const [volume, setVolume] = useState(1) // volume vai de 0 (mudo) até 1 (máximo)
  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60).toString().padStart(2, '0')
    const secs = Math.floor(seconds % 60).toString().padStart(2, '0')
    return `${mins}:${secs}`
  }

  const togglePlay = () => {
    if (!audioRef.current) return
    if (isPlaying) {
      audioRef.current.pause()
    } else {
      audioRef.current.play()
    }
    setIsPlaying(!isPlaying)
  }

  const toggleMute = () => {
    if (!audioRef.current) return
    const newVolume = audioRef.current.volume > 0 ? 0 : 1
    audioRef.current.volume = newVolume
    setVolume(newVolume)
  }

  const seek = (seconds) => {
    if (audioRef.current) {
      const audio = audioRef.current;
      let newTime = audio.currentTime + seconds;

      // Clamp the time between 0 and the duration
      newTime = Math.max(0, Math.min(newTime, audio.duration));

      audio.currentTime = newTime;
    }
  };

  return (
    <>
      <Container>
        <AudioHeader>
          <BannerContainer bgImage={ course?.image?.url ? parseStrapiImage(course?.image?.url) : course?.cover } />
          <AudioContent>
            <Content>

              <AudioTitle>
                {course.title}

              </AudioTitle>
              <TimeDisplay>
                <span>{formatTime(currentTime)}</span>
                /
                <span>{formatTime(totalDuration)}</span>
              </TimeDisplay>
            </Content>

            <audio
              ref={audioRef}
              src={parseStrapiImage(course?.audio?.url)}
              onTimeUpdate={() => setCurrentTime(audioRef.current.currentTime)}
              onLoadedMetadata={() => setTotalDuration(audioRef.current.duration)}
            />

            <ProgressBarContainer>
              <Progress style={{ width: totalDuration ? `${(currentTime / totalDuration) * 100}%` : '0%' }} />
            </ProgressBarContainer>

            <Controls>
              <ControlsContainer>

                <Icon icon={isPlaying ? 'pause' : 'play-white'} onClick={togglePlay} pointer />
                <Icon icon="prev" pointer onClick={() => seek(-5)} />
                <Icon icon="next" pointer onClick={() => seek(5)} />
              </ControlsContainer>
              <ControlsContainer>
                <Icon
                  icon={volume > 0 ? 'volume' : 'volume-muted'}
                  pointer
                  width={'24px'}
                  onClick={toggleMute}
                />
                <Icon icon="maximize" pointer />
              </ControlsContainer>
            </Controls>
          </AudioContent>
        </AudioHeader>
        <TitleContent>
          <OptionsIcon><Icon icon="audio" /></OptionsIcon>
          <Title>{course?.title}</Title>
        </TitleContent>
        <ExternalResourceLink course={course} />
      </Container>
    </>
  )
}
